import { useEffect, useState } from "react";
import { httpGet } from "../helpers/httpMethods";

// The reader's wallet (switch state, balance, recent activity) from GET /wallet/me.
// One request per sign-in, shared by the header, the account menu and the wallet panel.
// After a top-up the panel fires "tns:wallet-changed" and everyone reloads.
let cache = { token: null, promise: null };
const EMPTY = { enabled: false, balance: 0, hasWallet: false, limits: { min: 100, max: 500000 }, activity: [] };

export function loadWallet(fresh) {
  let token = "";
  try { token = localStorage.getItem("token") || ""; } catch (e) { token = ""; }
  if (!token) return Promise.resolve(EMPTY);
  if (fresh || cache.token !== token || !cache.promise) {
    cache = { token, promise: httpGet("wallet/me").then((r) => (r && r.data ? { ...EMPTY, ...r.data } : EMPTY)).catch(() => EMPTY) };
  }
  return cache.promise;
}

export function useWallet() {
  const [w, setW] = useState(EMPTY);
  useEffect(() => {
    let alive = true;
    const load = (fresh) => loadWallet(fresh).then((v) => alive && setW(v));
    const changed = () => load(true);
    load(false);
    window.addEventListener("tns:wallet-changed", changed);
    return () => { alive = false; window.removeEventListener("tns:wallet-changed", changed); };
  }, []);
  return w;
}

export const naira = (v) => {
  const n = Number(v) || 0;
  return `₦${n.toLocaleString("en-NG", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
};
